export default "__VITE_ASSET__BVsMiILu__"